import { Button } from '@/components/ui/button';
import { Check } from 'lucide-react';
import { useSignupEntityType, useSignupUrl } from '@/hooks/useSignupUrl';
import { trackLandingCtaClicked } from '@/lib/analytics';
import { useLandingSectionTracking } from '@/hooks/useLandingSectionTracking';
import { useTranslation } from '@/i18n/i18n';

export const CTASection = () => {
  const signupUrl = useSignupUrl({ source: 'cta_section' });
  const signupEntityType = useSignupEntityType();
  const sectionRef = useLandingSectionTracking('final_cta');
  const { t } = useTranslation();

  return (
    <section
      ref={sectionRef}
      className="py-20 px-6 md:px-8 bg-muted/40 border-t border-border relative overflow-hidden"
    >
      {/* Background decoration */}
      <div className="max-w-3xl mx-auto text-center relative z-10">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold mb-6 tracking-tight text-foreground">
          {t('cta.heading')
            .split('<primary>')
            .map((part, i) => {
              if (i === 0) return part;
              const [primary, rest] = part.split('</primary>');
              return (
                <span key={primary}>
                  <span className="text-primary">{primary}</span>
                  {rest}
                </span>
              );
            })}
        </h2>

        <p className="text-lg md:text-xl text-muted-foreground mb-10 max-w-2xl mx-auto">
          {t('cta.subheading')}
        </p>

        <Button
          size="lg"
          className="text-base font-bold px-10 h-14 rounded-full shadow-lg shadow-primary/25 hover:shadow-xl hover:shadow-primary/30 hover:scale-[1.02] transition-all duration-300"
          asChild
        >
          <a
            href={signupUrl}
            onClick={() =>
              trackLandingCtaClicked('final_cta', t('cta.button'), {
                entity_type: signupEntityType,
              })
            }
          >
            {t('cta.button')}
          </a>
        </Button>

        <div className="mt-8 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm text-muted-foreground">
          {[t('cta.setup'), t('cta.noCommitment')].map((item) => (
            <span key={item} className="inline-flex items-center gap-1.5">
              <Check className="size-4 text-success" />
              {item}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};
